import Sheet from 'react-modal-sheet';
import GalleryCarouselPage from '../../../pages/gallery/GalleryCarouselPage';

export default function CarouselModal(
    { 
        isCarouselModalOpen,
        onCarouselModalDismiss,
        images,
        currentIndex
    }
) {

    return <Sheet
     isOpen={isCarouselModalOpen} onClose={() => {onCarouselModalDismiss()}} onOpenEnd={() => {}} detent="full-height"
     >
        <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content className="bg-base-300">
        <Sheet.Scroller draggableAt="both">
        <div className="h-full">
        <GalleryCarouselPage placeImages={images} onBigCarouselBackPressed={onCarouselModalDismiss} currentPage={currentIndex}/>
        <div className="modal-action bg-base-100 w-full px-4 py-4 absolute bottom-0 right-0">
            <button className="btn btn-circle btn-soft" onClick={
                    () => {
                        onCarouselModalDismiss()
                    }
                    }>
                <svg className="fill-base-content w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z"/></svg>
            </button>
        </div>
        </div>
        </Sheet.Scroller>
        </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={(_) => {
            onCarouselModalDismiss()
        }}/>
    </Sheet>
}